import Vue from 'vue';
const state = {
    credit: {},
    credits: [],
}
const actions = {
    showCredits: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/credits`).then(response => {
                context.commit('SHOW_CREDITS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showCredit: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/credits/${id}`).then(response => {
                context.commit('SHOW_CREDIT', response.data.data)

                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storeCredit: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/credits`, payload).then(response => {
                context.commit('STORE_CREDIT', response.data)
                Vue.$toast.success("Pagamento registrado com sucesso");
                resolve(response)
            }).catch(error => {
                Vue.$toast.error("Não foi possível registrar, tente novamente.");
                reject(error)
            })
        })
    },
    updateCredit: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/credits/${payload.id}`, payload).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyCredit: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/credits/${id}`).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_CREDIT: (state, payload) => {
        state.credit = payload
    },
    SHOW_CREDITS: (state, payload) => {
        state.credits = payload
    },
    STORE_CREDIT: (state, payload) => {
        state.credit = payload
    }
}
const getters = {
    credit: state => {
        return state.credit
    },
    credits: state => {
        return state.credits
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
